import React from 'react';
import styled from 'styled-components';
import { media } from 'theme';
import ReactMarkdown from 'react-markdown';
import breaks from 'remark-breaks';

const StyleWrap = styled.div`
  word-wrap: break-word;
  width: 100%;
  font-family: Montserrat, Open Sans;

  a {
    color: ${props => props.theme.colors.seedlyBlue};
    text-decoration: underline;
  }

  ol,
  ul {
    margin: 16px 0;
  }

  li {
    font-size: 18px;
    padding: 0;
  }

  ol {
    li {
      list-style-type: decimal;
      list-style-position: outside;
      margin-left: 30px;
    }
  }

  ul {
    li {
      list-style-type: disc;
      list-style-position: outside;
      margin-left: 30px;
    }
  }

  img {
    max-width: 100%;
    padding-bottom: 28px;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    padding-bottom: 8px;
  }

  h1 {
    font-size: 26px;
    line-height: auto;
  }

  h2 {
    font-size: 26px;
    line-height: auto;
  }

  h3,
  h4,
  h5,
  h6 {
    font-size: 21px;
    line-height: auto;
  }

  p {
    font-size: 18px;
    margin-bottom: 30px;
    line-height: 30px;
    font-weight: 400;
  }

  ${media.largeAndDown`
    p {
      font-size: 16px;
      margin-bottom: 28px;
      line-height: 28px;
      font-weight: 400;
    }
  `}
`;
const Anchor = styled.a`
  &:link,
  &:visited {
    color: ${props => props.theme.colors.seedlyBlue};
  }
  &:hover {
    text-decoration: underline;
  }
`;

const Link = props => {
  return (
    <Anchor href={props.href} rel="ugc noopener noreferrer" target="_blank">
      {props.children}
    </Anchor>
  );
};

const VirtualHtml = props => {
  const style = { textDecoration: 'underline' };
  return React.createElement('span', { style }, props.children);
};

const addUnderline = (underlinedStringArr, source) => {
  let underlinedStr = source;

  // eslint-disable-next-line no-plusplus
  for (let x = 0; x < underlinedStringArr.length; x++) {
    if (underlinedStringArr[x]) {
      const withUnderlineTag = `<span>${underlinedStringArr[x].replace(
        /\+{2}(.*?)\+{2}/g,
        `$1`,
      )}</span>`;
      underlinedStr = underlinedStr.replace(
        underlinedStringArr[x],
        withUnderlineTag,
      );
    }
  }

  return underlinedStr;
};

const OpinionContentMarkdown = ({ source }) => {
  const underlinedStringArr = source.match(/\+{2}(.*?)\+{2}/g);
  const underlinedStr =
    underlinedStringArr && underlinedStringArr.length > 0
      ? addUnderline(underlinedStringArr, source)
      : source;

  const formattedStr = underlinedStr.replace(/[\u200B-\u200D\uFEFF]/g, ' ');

  return (
    <StyleWrap>
      <ReactMarkdown
        renderers={{
          link: Link,
          virtualHtml: VirtualHtml,
          image: ({ node, ...props }) => (
            <img {...props} loading="lazy" alt={props.alt} />
          ),
        }}
        source={formattedStr}
        escapeHtml={false}
        plugins={[breaks]}
      />
    </StyleWrap>
  );
};

export default OpinionContentMarkdown;
